import { render, staticRenderFns } from "./itemsign.vue?vue&type=template&id=21d24240&scoped=true&"
import script from "./itemsign.vue?vue&type=script&lang=js&"
export * from "./itemsign.vue?vue&type=script&lang=js&"
import style0 from "./itemsign.vue?vue&type=style&index=0&id=21d24240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d24240",
  null
  
)

export default component.exports